import { configureStore } from '@reduxjs/toolkit';
import productReducer from './reducers/Home-Filter/products';

import ContantUploadForVoucherReducer from './reducers/ContantUploadForVoucher';
import CurrentPageCountReducer from './reducers/Home-Filter/CurrentPageCount';
import FilterReducer from './reducers/Home-Filter/Fillter';
import orderProgressReducer from './reducers/Order-Tracking/Order-Progress-Status';
import PaginationCountReducer from './reducers/PaginationCount';
import createOrderReducer from './reducers/PaymentGetway/CreateOrder';
import paymentVerifieReducer from './reducers/PaymentGetway/PaymentVerifie';
import ProductAnalysisReducer from './reducers/Products/ProductAnalysis';
import ProductAnalysisDataOfLastFiveYearsReducer from './reducers/Products/ProductAnalysisData/ProductAnalysisDataOfLastFiveYears';
import ProductAnalysisDataOfLastMonthReducer from './reducers/Products/ProductAnalysisData/ProductAnalysisDataOfLastMonth';
import ProductAnalysisDataOfLastWeekReducer from './reducers/Products/ProductAnalysisData/ProductAnalysisDataOfLastWeek';
import ProductAnalysisDataOfLastYearReducer from './reducers/Products/ProductAnalysisData/ProductAnalysisDataOfLastYear';
import ProductAnalysisDataOfSixMonthReducer from './reducers/Products/ProductAnalysisData/ProductAnalysisDataOfSixMonth';
import ProductAnalysisDataOfThreeMonthReducer from './reducers/Products/ProductAnalysisData/ProductAnalysisDataOfThreeMonth';
import ProductAnalysisUpdateReducer from './reducers/Products/ProductAnalysisUpdate';
import setEmailAndNotificationReducer from './reducers/SendEmailAndNotification/setEmailAndNotification.js';

import getNotificationReducer from './reducers/Notification/getNotications';
import notificationReducer from './reducers/Notification/notification';

import { removeWishlistReducer } from './reducers/Wishlist';

import OrderSummarySlice from './reducers/OrderSummary';
import addToWishlistReducer from './reducers/WishlistReducer/AddWishlist';
import wishlistReducer from './reducers/WishlistReducer/Wishlist';
import wallet_slice from './Slices/wallet_statement.js';

import {
  addToCartReducer,
  cartReducer,
  removeFromCartReducer,
} from './reducers/CartReducer';
import { UpdateCompanyPreferenceSlice } from './reducers/Company/CompanyPreference';
import { GetCompanyTypeSlice } from './reducers/Company/CompanyTypeReducer';
import { GetLoggedCompanySlice } from './reducers/Company/GetLoggedCompany';
import { GetProductByIdSlice } from './reducers/ProductReducer/GetProductByIdReducer';
import {
  AllListedProductByCompanySlice,
  ListedDraftProductsByCompanySlice,
  ListedProductsByCompanySlice,
  AllRejectedProductByCompanySlice,
  AllDelistProductByCompanySlice,
  AllPendingProductByCompanySlice,
} from './reducers/ProductReducer/ListedProductsByCompany';
import BulkUploadProductReducer from './reducers/Products/Bulkuploadproduct.js';
import MediaBulkUploadProductReducer from './reducers/Products/MediaBulkuploadproductToDB.js';

// PO removed: Order Request flow used instead. Stub reducers for any legacy reads.
const purchaseOrderListStub = () => ({ loading: false, orders: [] });
const purchaseOrderDetailsStub = () => ({ loading: false, order: null });

import { companyByIdSlice, companySlice } from './reducers/CompanyReducer';
import totalPurchaseReducer from './reducers/DashBoard/Total-Purchase';
import totalSalesReducer from './reducers/DashBoard/Total-Sales';
import OrderTrackingReducer from './reducers/Order-Tracking/Order-Tracking-Status';
import OrderDetailsReducer from './reducers/Order-Tracking/OrderDetailes';
import editProfileReducer from './reducers/Profile/Edit-Profile';
import profileCompletionReducer from './reducers/Profile/Profile-Completion';
import invoicesReducer from './reducers/invoices';
import AddContactReducer from './reducers/WhatApp/AddContact';
import SendMessagesReducer from './reducers/WhatApp/SendMessages';
import ProductExploreReducer from './reducers/Products/products.js';

const store = configureStore({
  reducer: {
    products: productReducer,
    productExplore: ProductExploreReducer,

    wishlists: wishlistReducer,
    removeWishlist: removeWishlistReducer,
    addWishlist: addToWishlistReducer,
    cart: cartReducer,
    addCart: addToCartReducer,
    removeCart: removeFromCartReducer,
    purchaseOrderList: purchaseOrderListStub,
    purchaseOrderDetails: purchaseOrderDetailsStub,
    companyDetails: companySlice.reducer,
    companyById: companyByIdSlice.reducer,

    notification: notificationReducer,
    allNotifications: getNotificationReducer,
    bulkUpload: BulkUploadProductReducer,
    MediaBulkUpload: MediaBulkUploadProductReducer,
    totalSales: totalSalesReducer,
    totalPurchase: totalPurchaseReducer,
    editProfile: editProfileReducer,
    profileCompletion: profileCompletionReducer,
    invoices: invoicesReducer,
    orderTracking: OrderTrackingReducer,
    ProductAnalysis: ProductAnalysisReducer,
    ProductAnalysisUpdate: ProductAnalysisUpdateReducer,
    ProductAnalysisOfWeek: ProductAnalysisDataOfLastWeekReducer,
    ProductAnalysisOfLastMonth: ProductAnalysisDataOfLastMonthReducer,
    ProductAnalysisOfThreeMonth: ProductAnalysisDataOfThreeMonthReducer,
    ProductAnalysisOfSixMonth: ProductAnalysisDataOfSixMonthReducer,
    ProductAnalysisOfLastYear: ProductAnalysisDataOfLastYearReducer,
    ProductAnalysisOfLastFiveYear: ProductAnalysisDataOfLastFiveYearsReducer,
    createOrder: createOrderReducer,
    paymentVerify: paymentVerifieReducer,
    OrderProgress: orderProgressReducer,
    PaginationCount: PaginationCountReducer,
    CurrentPage: CurrentPageCountReducer,
    AllFilter: FilterReducer,
    ContentUpload: ContantUploadForVoucherReducer,
    OrderDetails: OrderDetailsReducer,
    AddContact: AddContactReducer,
    SendMessages: SendMessagesReducer,
    SendNotificationAndEmail: setEmailAndNotificationReducer,

    OrderSummaryD: OrderSummarySlice,
    CompanyType: GetCompanyTypeSlice.reducer,
    CompanyPreference: UpdateCompanyPreferenceSlice.reducer,
    ListedProductsByCompany: ListedProductsByCompanySlice.reducer,
    GetLoggedCompany: GetLoggedCompanySlice.reducer,
    GetProductById: GetProductByIdSlice.reducer,
    ListedDraftProductsByCompany: ListedDraftProductsByCompanySlice.reducer,
    AllListedProductByCompany: AllListedProductByCompanySlice.reducer,
    AllRejectedProductByCompany: AllRejectedProductByCompanySlice.reducer,
    AllDelistProductByCompany: AllDelistProductByCompanySlice.reducer,
    AllPendingProductByCompany: AllPendingProductByCompanySlice.reducer,
    wallet: wallet_slice,
  },
});

export default store;

// Home Filter Reducer


